import messagesEn from './en.json'
import messagesZh from './zh.json'

export default {
  'en': messagesEn,
  'zh': messagesZh,
};
